export default __webpack_public_path__ + "static/media/title-emergency.d9c8e6dc.png";